<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Kategori</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'car'}">Data Kategori</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-12">
                                            <label>Nama</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Kategori Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-12 mt-3">
                                            <label>Plat Nomor</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.number_plate" :class="{ 'is-invalid': submitted && $v.form.number_plate.$error }">
                                            <div v-if="submitted && !$v.form.number_plate.required" class="invalid-feedback">Plat Nomor Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Harga Sewa</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.price" :class="{ 'is-invalid': submitted && $v.form.price.$error }">
                                            <div v-if="submitted && !$v.form.price.required" class="invalid-feedback">Harga Sewa Wajib diisi!</div>    
                                            <div v-if="submitted && !$v.form.price.numeric" class="invalid-feedback"> Harga Sewa harus berupa angka</div>
                                        </div>
                                        <div class="form-group col-md-6 mt-3">
                                            <label for="exampleFormControlSelect1">Status</label>
                                            <select class="form-select" id="exampleFormControlSelect1" v-model="form.status">
                                                <option value="publish">Publish</option>
                                                <option value="draft">Draft</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Kategori</label>
                                            <v-select
                                                placeholder="Pilih Kategori"
                                                label="name"
                                                :options="dataCategory"
                                                v-model="form.category"
                                                :class="{ 'is-invalid': submitted && $v.form.category.$error }"
                                                >                                    
                                            </v-select>

                                            <div v-if="submitted && !$v.form.category.required" class="invalid-feedback" style="display:block !important"> Kategori Wajib diisi!</div>
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'car'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required, numeric
    } from "vuelidate/lib/validators";
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    
    export default {
        name: 'car',
        metaInfo: {
            title: 'Form Kategori',
            titleTemplate: '%s - Katarda'
        },
        components : {
            'v-select' : vSelect
        },
        created() {
            this.getCategory();
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id           : "",
                    category     : [],
                    name         : "",
                    number_plate : "",
                    price        : "",
                    status       : "draft",
                },
                dataCategory         : [],
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
                category: {
                    required
                },
                number_plate: {
                    required
                },
                price: {
                    required,
                    numeric
                },
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('category_id', this.form.category.id);
                    formData.append('name', this.form.name);
                    formData.append('number_plate', this.form.number_plate);
                    formData.append('price', this.form.price);
                    formData.append('status', this.form.status);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/car/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'car' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/car/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id            = getResponse.id;
                            this.form.name          = getResponse.name;
                            this.form.number_plate  = getResponse.number_plate;
                            this.form.status        = getResponse.status;
                            this.form.price         = getResponse.price;
                            this.form.category      = getResponse.category[0];

                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'car' });
                                }
                            });
                        }
                    });
                }
            },
            getCategory: function() {
                let uri = process.env.VUE_APP_APIHOST+'admin/car/category_list';
                this.$http.get(uri).then(res => {
                    this.dataCategory  = res.data.data;
                });
            },
        }
    }
</script>